import { createAction } from '@saucelabs/sl-util-redux';

import * as types from './types';

export const selectCommand = createAction(types.COMMAND_SELECT);
export const selectCommandIcon = createAction(types.COMMAND_ICON_SELECT);
export const updateActiveCommand = createAction(types.UPDATE_ACTIVE_COMMAND);
export const cleanup = createAction(types.CLEANUP);
export const assetsExpired = createAction(types.ASSETS_EXPIRED);
export const noTestCasesAvailable = createAction(types.NO_TEST_CASES_AVAILABLE);
export const noCommandsAvailable = createAction(types.NO_COMMANDS_AVAILABLE);

export const parseCypressLogs = createAction(types.PARSE_CYPRESS_JOB);
export const parsePlaywrightLogs = createAction(types.PARSE_PLAYWRIGHT_JOB);
export const parseTestCafeLogs = createAction(types.PARSE_TESTCAFE_JOB);
export const parseCucumberLogs = createAction(types.PARSE_CUCUMBER_JOB);

export const showTestReport = createAction(types.SHOW_TEST_REPORT);

export const parseTestfairyLogs = createAction(types.PARSE_TESTFAIRY_LOGS);

export const parseCrashLogs = createAction(types.PARSE_CRASH_LOGS);

export const selectScreenshot = createAction(types.SELECT_SCREENSHOT);
